import { FormBlueprint } from '../../interfaces/components/dynamic-form'

const fileDescription = `### Empfohlene Bild Spezifikation

- Empfohlene Bildgrove: 1200 x 628 pixels
- Empfohlene Bildgrove: 1:1 pixels
- Um die Auslieferung der webeanzeige
`

export const MultifileCreative: FormBlueprint = {
  name: 'multifile-creative',
  fields: [
    {
      step: 10,
      type: 'list',
      name: 'creatives',
      label: 'Creatives',
      description: '',
      mandatory: false,
      meta: {
        of: {
          step: 10,
          type: 'fieldset',
          name: 'creative',
          label: 'Creative',
          mandatory: true,
          description: 'Description for text',
          fields: [
            {
              step: 10,
              type: 'select',
              mandatory: true,
              name: 'creative_type',
              label: 'Select type',
              meta: {
                as: 'grid',
                multiple: true,
                options: [
                  { label: 'Picture', value: 'picture' },
                  { label: 'Video', value: 'video' },
                  { label: 'Slideshow', value: 'slideshow' },
                ],
              },
              description: '',
            },
            {
              step: 10,
              name: 'file',
              label: '',
              description: fileDescription,
              mandatory: true,
              type: 'file',
              meta: {
                maximumSize: 25,
                multiple: false,
                allowedTypes: ['image/jpeg', 'image/png'],
              },
            },

            {
              step: 10,
              name: 'title',
              label: 'Title',
              description: 'Description for text',
              type: 'text',
              mandatory: true,
            },
            {
              step: 10,
              name: 'description',
              label: 'Description',
              description: 'Description for description',
              type: 'text',
              mandatory: true,
            },
            {
              step: 10,
              name: 'url',
              label: 'Target-URL',
              description: 'Description for target url',
              type: 'text',
              mandatory: false,
            },
          ],
        },
      },
    },
    {
      step: 20,
      name: 'text',
      label: 'Text',
      description: 'Description for text',
      type: 'text',
      mandatory: true,
    },
    {
      step: 30,
      name: 'url',
      label: '"Show more" URL',
      description: 'Description for url',
      type: 'text',
      mandatory: true,
    },
    {
      step: 40,
      name: 'links',
      label: 'Links shown as "Show more" URL',
      description: 'Description for links',
      type: 'text',
      mandatory: true,
    },
    {
      step: 50,
      name: 'call_to_action',
      label: 'Call to action',
      description: 'Description for call to action',
      mandatory: true,
      type: 'select',
      meta: {
        as: 'dropdown',
        multiple: false,
        options: [
          { value: '1', label: 'Weitere Infos' },
          { value: '2', label: 'Weitere Infos 1' },
        ],
      },
    },
  ],
}

export const SingleFileCreative: FormBlueprint = {
  name: 'singlefile-creative',
  fields: [
    {
      step: 10,
      name: 'file',
      label: '',
      description: fileDescription,
      mandatory: true,
      type: 'file',
      meta: {
        maximumSize: 25,
        multiple: false,
        allowedTypes: ['image/jpeg', 'image/png'],
      },
    },

    {
      step: 20,
      name: 'text',
      label: 'Text',
      description: 'Description for text',
      type: 'text',
      mandatory: true,
    },
    {
      step: 30,
      name: 'url',
      label: '"Show more" URL',
      description: 'Description for url',
      type: 'text',
      mandatory: true,
    },
    {
      step: 40,
      name: 'links',
      label: 'Links shown as "Show more" URL',
      description: 'Description for links',
      type: 'text',
      mandatory: false,
    },
    {
      step: 50,
      name: 'call_to_action',
      label: 'Call to action',
      description: 'Description for call to action',
      mandatory: true,
      type: 'select',
      meta: {
        as: 'dropdown',
        multiple: false,
        options: [
          { value: '1', label: 'Weitere Infos' },
          { value: '2', label: 'Weitere Infos 1' },
        ],
      },
    },
  ],
}
